import { applyForChangeLocalization } from '../../pages/ApplyForChange/localizations';
import { changeRequestsLocalization } from '../../pages/ChangeRequests/localizations';
import { mentorSupportPayoutLocalization } from '../../pages/Forms/forms/MentorSupportPayout/mentorSupportPayoutApplication.localization';
import { authenticationLocalization } from '../../pages/Forms/localizations/authenticationLocalization';
import { formIdentifiers } from '../../pages/Forms/localizations/formIdentifiers';
import { formLocalization } from '../../pages/Forms/localizations/formLocalization';
import { receiptLocalization } from '../../pages/Forms/localizations/receiptLocalization';
import { tasksListLocalization } from '../../pages/Home/tasksList.localization';
import { deMinimisAidApplicationLocalization } from '../../pages/Koble/Forms/forms/DeMinimisAid/DeMinimisAidApplication.localization';
import { finalReportGrantSimpleApplication } from '../../pages/Koble/Forms/forms/FinalReportGrantSimple/FinalReportGrantSimpleApplication.localization';
import { maintenanceAmendmentOfTermsApplication } from '../../pages/Koble/Forms/forms/MaintenanceAmendmentOfTerms/MaintenanceAmendmentOfTermsApplication.localization';
import { maintenancePriorityDeviationApplication } from '../../pages/Koble/Forms/forms/MaintenancePriorityDeviation/MaintenancePriorityDeviationApplication.localization';
import { payoutRequestGrantSimpleLocalization } from '../../pages/Koble/Forms/forms/PayoutRequestGrantSimple/PayoutRequestGrantSimple.localization';
import { releaseOfCollateralsLocalization } from '../../pages/Koble/Forms/forms/ReleaseOfCollaterals/releaseOfCollateralsLocalization';
import { Localizations } from '../../utils/localizer';
import { localizationBankAccountList } from './localizationBankAccountsList';
import { deferralPaymentLocalization } from './localizationDeferralPayment';
import { localizationNavMenu } from './localizationNavMenu';
import { appealDecisionLocalization } from './localizationsAppealDecision';
import { applicationDetails } from './localizationsApplicationDetails';
import { breadCrumbs } from './localizationsBreadcrumbs';
import { collaterals } from './localizationsCollaterals';
import { confirmContactDetails } from './localizationsConfirmContactDetails';
import { customerTasks } from './localizationsCustomerTasks';
import { customerTasksList } from './localizationsCustomerTasksList';
import { dateRange } from './localizationsDateRange';
import { documentList } from './localizationsDocumentList';
import { customerDocuments } from './localizationsDocuments';
import { errorBoundary } from './localizationsErrorBoundary';
import { filterChipGroup } from './localizationsFilterChipGroup';
import { filterDialog } from './localizationsFilterDialog';
import { financingFormSelection } from './localizationsFinancingFormSelection';
import { form } from './localizationsForm';
import { formAction } from './localizationsFormAction';
import { formRetired } from './localizationsFormRetired';
import { generalApplications } from './localizationsGeneralApplications';
import { grantDetails } from './localizationsGrantDetails';
import { guaranteeDetails } from './localizationsGuaranteeDetails';
import { headerLocalization } from './localizationsHeader';
import { interestSubsidyDetails } from './localizationsInterestSubsidyDetails';
import { invoicesLocalization } from './localizationsInvoices';
import { loanDetailsLocalization } from './localizationsLoanDetails';
import { pagerText } from './LocalizationsPagerText';
import { paymentPlanLocalization } from './localizationsPaymentPlan';
import { projectAccounting } from './localizationsProjectAccounting';
import { submittedFormLocalization } from './localizationsSubmittedForm';
import { transactionOverview } from './localizationsTransactionOverview';

const localizations: Localizations = {
  ApplicationDetails: applicationDetails,
  ChangeRequests: changeRequestsLocalization,
  ApplyForChange: applyForChangeLocalization,
  AppealDecision: appealDecisionLocalization,
  DocumentList: documentList,
  InterestSubsidyDetails: interestSubsidyDetails,
  PaymentPlan: paymentPlanLocalization,
  LoanDetails: loanDetailsLocalization,
  GrantDetails: grantDetails,
  GuaranteeDetails: guaranteeDetails,
  FinancingFormSelection: financingFormSelection,
  TransactionOverview: transactionOverview,
  Collaterals: collaterals,
  CaseNumber: generalApplications,
  Invoices: invoicesLocalization,
  CustomerDocuments: customerDocuments,
  PagerText: pagerText,
  DateRange: dateRange,
  ConfirmContactDetails: confirmContactDetails,
  Form: form,
  FormAction: formAction,
  SubmittedForm: submittedFormLocalization,
  BreadCrumbs: breadCrumbs,
  CustomerTasksList: customerTasksList,
  ProjectAccounting: projectAccounting,
  CustomerTasks: customerTasks,
  BankAccountList: localizationBankAccountList,
  releaseOfCollateralsApplication: releaseOfCollateralsLocalization,
  mentorSupportPayoutLocalization: mentorSupportPayoutLocalization,
  maintenancePriorityDeviationLocalization: maintenancePriorityDeviationApplication,
  finalReportGrantSimpleLocalization: finalReportGrantSimpleApplication,
  maintenanceAmendmentOfTermsApplication: maintenanceAmendmentOfTermsApplication,
  deMinimisAidApplicationLocalization: deMinimisAidApplicationLocalization,
  payoutRequestGrantSimpleLocalization: payoutRequestGrantSimpleLocalization,
  formLocalization: formLocalization,
  receiptLocalization: receiptLocalization,
  authenticationLocalization: authenticationLocalization,
  NavMenu: localizationNavMenu,
  NewHeader: headerLocalization,
  tasksListLocalization,
  ErrorBoundary: errorBoundary,
  FormIdentifiers: formIdentifiers,
  FilterDialog: filterDialog,
  FilterChipGroup: filterChipGroup,
  FormRetired: formRetired,
  deferralPaymentLocalization,

  Global: {
    documentTitle: {
      en: 'My Page',
      nb: 'Min side',
      nn: 'Min side',
    },
    pageTitle: {
      en: 'Online Banking',
      nb: 'Nettbank',
      nn: 'Nettbank',
    },
    loading: {
      en: 'Loading...',
      nb: 'Laster...',
      nn: 'Lastar...',
    },
    goBackLabel: {
      en: 'Back',
      nb: 'Tilbake',
      nn: 'Tilbake',
    },
    backToAccountOverview: {
      en: 'Back to Account overview',
      nb: 'Tilbake til Kontooversikt',
      nn: 'Tilbake til Kontooversikt',
    },
    myAgreements: {
      en: 'My agreements',
      nb: 'Mine avtaler',
      nn: 'Mine avtalar',
    },
    noClearanceToSeeFinancialSupportForCompany: {
      nb: `For å se informasjon i Nettbank må du ha en registrert rolle i Brønnøysundregistrene. Det er ikke mulig å gi tilgang til andre personer, som for eksempel revisor, regnskapsfører eller prosjektleder.

    Tilgang for personer med prokura eller signatur kan være begrenset dersom et styremedlem er registrert som fratrådt i Brønnøysundregistrene. Ny registermelding må sendes inn via Altinn.`,
      nn: `For å sjå informasjon i Nettbank må du ha ei registrert rolle i Brønnøysundregistrene. Det er ikkje mogleg å gje tilgang til andre personar, som til dømes revisor, rekneskapsførar eller prosjektleiar.

    Tilgang for personar med prokura eller signatur kan vere avgrensa dersom eit styremedlem er registrert som fratrådd i Brønnøysundregistrene. Ny registermelding må då sendast inn via Altinn.`,
      en: `For access to the information in our Online Banking, you must be registered with an official role in the Brønnøysund Register Centre. It is unfortunately not, as of yet, possible to grant access to other individuals, such as an auditor, accountant, or project manager.

    Access for persons with procuration or signature may be restricted if a board member is registered as resigned in the Brønnøysund Register Centre. A new registration notice must then be submitted via Altinn.`,
    },
    loadingSpinner: {
      en: 'Loading..',
      nb: 'Laster inn..',
      nn: 'Lastar inn..',
    },
    skipToMainContent: {
      en: 'Skip to main content',
      nb: 'Hopp til hovedinnhold',
      nn: 'Hopp til hovedinnhald',
    },
  },
  Navigation: {
    bankAccounts: {
      en: 'Account overview',
      nb: 'Kontooversikt',
      nn: 'Kontooversikt',
    },
    caseManagement: {
      en: 'Case Management',
      nb: 'Saksbehandling',
      nn: 'Saksbehandling',
    },
    documents: {
      en: 'Documents and letters',
      nb: 'Dokumenter og brev',
      nn: 'Dokumenter og brev',
    },
    menuAriaLabel: {
      en: 'Application details menu',
      nb: 'Søknadsdetaljer meny',
      nn: 'Søknadsdetaljar meny',
    },
  },
  BankAccountSummaryCard: {
    loan: {
      en: 'loan',
      nb: 'lån',
      nn: 'lån',
    },
    grant: {
      en: 'grant',
      nb: 'tilskudd',
      nn: 'tilskot',
    },
    guarantee: {
      en: 'guarantee',
      nb: 'garanti',
      nn: 'garanti',
    },
    backingguarantee: {
      en: 'Guarantee for Growth',
      nb: 'vekstgaranti',
      nn: 'vekstgaranti',
    },
    interestsubsidy: {
      en: 'interest subsidy',
      nb: 'rentestøtte',
      nn: 'rentestønad',
    },
    projectNo: {
      en: 'reference',
      nb: 'referanse',
      nn: 'referanse',
    },
    loanLabel: {
      en: 'balance',
      nb: 'saldo',
      nn: 'saldo',
    },
    grantLabel: {
      en: 'available',
      nb: 'tilgjengelig',
      nn: 'tilgjengeleg',
    },
    guaranteeLabel: {
      en: 'guaranteed',
      nb: 'garantert',
      nn: 'garantert',
    },
    backingGuaranteeLabel: {
      en: 'guaranteed',
      nb: 'garantert',
      nn: 'garantert',
    },
    interestSubsidyLabel: {
      en: 'Basis for calculation',
      nb: 'Beregningsgrunnlag',
      nn: 'Beregningsgrunnlag',
    },
    noAgreementText: {
      en: 'No accounts to show.',
      nb: 'Det er ingen kontoer i denne listen.',
      nn: 'Det er ingen kontoar i denne lista.',
    },
    cardTitleMissingPayment: {
      en: 'Not paid by the due date',
      nb: 'Ikke betalt til betalingsfrist',
      nn: 'Ikkje betalt til betalingsfrist',
    },
    cardTitleSentForDebtCollection: {
      en: 'Sent for debt collection',
      nb: 'Sendt til inkasso',
      nn: 'Sendt til inkasso',
    },
    goto: {
      en: 'Go to',
      nb: 'Gå til',
      nn: 'Gå til',
    },
    formActionEmpty: {
      en: 'No action available',
      nb: 'Ingen handling tilgjengelig',
      nn: 'Ingen handling tilgjengeleg',
    },
    formActionError400: {
      en: 'An error has occured',
      nb: 'En feil har oppstått',
      nn: 'Ein feil har oppstått',
    },
    formActionError500: {
      en: 'An error has happened, try again later',
      nb: 'En feil har oppstått, prøv igjen senere',
      nn: 'Ein feil har oppstått, prøv igjen seinare',
    },
    formActionOpenPanel: {
      en: 'Open payout panel',
      nb: 'Åpne utbetalingspanel',
      nn: 'Opne utbetalingspanel',
    },
  },
  CheckBox: {
    selectInvoiceLabel: {
      en: 'Selected invoice number',
      nb: 'Valgt fakturanummer',
      nn: 'Valt fakturanummer',
    },
    projectAccountingLabel: {
      en: 'Project accounting',
      nb: 'Prosjektregnskap',
      nn: 'Prosjektrekneskap',
    },
    selectLoanLabel: {
      en: 'Selected loan',
      nb: 'Valgt lån',
      nn: 'Valt lån',
    },
    deleteLabel: {
      en: 'Delete',
      nb: 'Slett',
      nn: 'Slett',
    },
    draftDeletionMessage: {
      en: 'Drafts will be automatically deleted 90 days after the last change.',
      nb: 'Kladder vil automatisk slettes 90 dager etter siste endring.',
      nn: 'Kladdar vil automatisk bli sletta 90 dagar etter siste endring.',
    },
    disabledButtonTitle: {
      en: 'The form can not be stored',
      nb: 'Skjemaet kan ikke lagres',
      nn: 'Skjemaet kan ikkje lagrast',
    },
  },
} as const;

export { localizations };
